const actionTypes = {
  UPDATE_TIMER_SUCCESS: 'timer/UPDATE_TIMER_SUCCESS',
  UPDATE_TIMER_REQUEST: 'timer/UPDATE_TIMER_REQUEST',
  UPDATE_TIMER_ERROR: 'timer/UPDATE_TIMER_ERROR',
};
export default actionTypes;
